import { useState } from "react";
import { HeaderText } from "../../menu/muiStyles";
import useGlobal from "../../util/Global";
import { Box, FormControlLabel, Grid, Radio, RadioGroup, Typography } from "@mui/material";

const DynamicTabComponent = ({ tabOptions, onTabChangeEvent = null, selectedTab, disabled, title = '' }) => {

    const { t } = useGlobal();


    return (
        <Box sx={{ p: 2, textAlign: "center", backgroundColor: "#f0f0f0", height: "100%" }} >
            <HeaderText variant="h5">{title}</HeaderText>

            <RadioGroup value={selectedTab} onChange={(e) => {

                if (onTabChangeEvent)
                    onTabChangeEvent(e.target.value);

                // setSelectedTab(e.target.value)
            }}>
                {tabOptions && tabOptions.map((option, index) => (
                    <Box key={index} sx={{ pl: 5, textAlign: "left", mt: 0, pt: 0 }}>
                        <FormControlLabel
                            key={option.id}
                            value={option.id}
                            disabled={disabled}
                            control={
                                <Radio
                                    sx={{
                                        pt: 1,
                                        color: Number(selectedTab) === Number(option.id) ? "error.main" : "text.secondary",
                                        "&:hover": { color: "text.light" }, // Hover color

                                    }}
                                />
                            }
                            label={
                                <Typography
                                    sx={{
                                        fontSize: '1rem',
                                        color: Number(selectedTab) === Number(option.id) ? "text.primary" : "grey.600",
                                        "&:hover": { color: "text.primary", backgroundColor: "info" }, // Hover color
                                        fontWeight: Number(selectedTab) === Number(option.id) ? "bold" : "normal", // Bold when selected
                                    }}
                                >
                                    {option.display}
                                </Typography>
                            }
                        />

                    </Box>
                ))}
            </RadioGroup>

        </Box>
    )
}

export default DynamicTabComponent;